//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import action from './action';
import { Swipe, SwipeItem, Popup, Actionsheet, List } from 'vant';
import { goodsItem, videoItem, commentItem, dataController, yList } from 'components/app';
import ylpList from 'components/list/index';
import PullTo from 'vue-pull-to'
export default {
  name: 'index',
  props: ['params'],
  metaInfo() {
    return {
      title: this.pageTitle
    };
  },
  components: {
    Swipe, SwipeItem, Popup, goodsItem, videoItem, Actionsheet, commentItem, ylpList, PullTo, dataController, yList, "van-list": List
  },
  async created() {
    await this.init();
  },
  data() {
    return {
      videoData: {
        code: undefined,
        data: {},
        msg: undefined,
      }, // 视频数据
      emptyData: {
        text: '视频已下架',
        image: '/static/img/app/no_video.png'
      },
      pageTitle: undefined, // 视频页标题
      commentData: { // 评论数据
        code: undefined,
        data: {},
        msg: undefined
      },
      recommendList: {
        code: undefined,
        data: {},
        msg: undefined
      },
      isLoading: false,
      loading: false,
      finished: false,
      page: 0,
      list: { // 推荐视频列表
        page: 1,
        items: []
      },
      isPlay: false,
      onInput: false,
      style: '',
      videoError: false,
      commentNum: 0,
      isLiked: 0,
      likeNum: 0,
      hotCommentList: {
        code: undefined,
        data: [],
        msg: undefined
      },
    }
  },
  methods: {
    ...action
  },
  watch: {
    '$route' (to, from) {
      //刷新参数放到这里里面去触发就可以刷新相同界面了
      this.init();
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/app/video/page.vue